import * as React from 'react'
import { usePathname } from 'solito/navigation'
import { useRouter } from 'solito/router'
import { primary, white } from '@themes/Colors'
import { RoundedButton } from './RoundedButton'

export function GoBackButton() {
  const router = useRouter()
  const pathName = usePathname()

  return (
    <RoundedButton
      onPress={() => {
        if (!pathName) router.push('/')
        else router.back()
      }}
      text="Go Back"
      backgroundColor={primary}
      textColor={white}
    />
  )
}
